export default "__VITE_ASSET__C_W9LkKd__"